// extracted by mini-css-extract-plugin
export default {"search":"e5X8RwqElyjCNPwSCn1d"};